    import {all, call, put, select, take, takeEvery} from 'redux-saga/effects';
import {AuditLoggingDownloadActions, DOWNLOAD_AUDIT_LOGGING_FAILED, DOWNLOAD_AUDIT_LOGGING_SUCCESSFULLY} from "./audit-logging-download.actions";
import {AdminPhiAuditLogHttpClient, FileResponse} from 'admins-dashboard';
import {AuditLoggingDownloadQuery} from "../models/audit-logging-download-query";
import {base64ToBlob, ENQUEUE_SNACKBAR, OperationErrorPipe, StoreAction} from "orpyx-web-common";
import FileSaver from "file-saver";
import {ORPYXSI_ADMIN_URL} from "../../../../appConstants";

const API_VERSION = '1';

function* onDownloadAuditLogging(action: StoreAction<AuditLoggingDownloadQuery>) {
    const query = action.payload!;
    const api = new AdminPhiAuditLogHttpClient(ORPYXSI_ADMIN_URL);
    try {

        const data: FileResponse = yield call(
            [api, api.audit],
            query.begin,
            query.end,
            query.organizationId,
            query.actorType,
            query.accessType,
            query.actorIdentifier,
            query.patientIdentifier,
            query.patientOptions,
            API_VERSION
        );

        yield put(DOWNLOAD_AUDIT_LOGGING_SUCCESSFULLY());
        yield put(ENQUEUE_SNACKBAR({
            message: `Successfully downloaded audit logging report`,
            options: {variant: "success"}
        }));

        const blob = base64ToBlob(data.content!, data.contentType!);
        FileSaver.saveAs(blob, data.fileName!);
    } catch (e) {
        yield put(DOWNLOAD_AUDIT_LOGGING_FAILED(e));
        yield put(ENQUEUE_SNACKBAR({
            message: `Failed download audit logging report, error: ${OperationErrorPipe(e)}`,
            options: {variant: "error"}
        }));
    }
}

export default function* AuditLoggingDownloadSages() {
    yield all([
        yield takeEvery(AuditLoggingDownloadActions.DOWNLOAD_AUDIT_LOGGING, onDownloadAuditLogging),
    ]);
}
